"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _isBreakpoint = require("../../utils/is-breakpoint");
var _useWindowWidth = _interopRequireDefault(require("../../utils/use-window-width"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var _default = exports["default"] = function _default(_ref) {
  var wrapperRef = _ref.wrapperRef,
    showTooltip = _ref.showTooltip;
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    leftOffset = _useState2[0],
    setLeftOffset = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    rightOffset = _useState4[0],
    setRightOffset = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    useNaturalPosition = _useState6[0],
    setUseNaturalPosition = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    childIsLarger = _useState8[0],
    setChildIsLarger = _useState8[1];
  var windowWidth = (0, _useWindowWidth["default"])();
  var isMobile = (0, _isBreakpoint.isMobileBreakpoint)(windowWidth);
  var getTooltipWidth = function getTooltipWidth() {
    var tooltipContentWidth = 352;
    var breakpointMdHorizontalPadding = 48;
    var breakpointLgHorizontalPadding = 80;
    return (0, _isBreakpoint.isMediumBreakpoint)(windowWidth) ? tooltipContentWidth + breakpointMdHorizontalPadding : tooltipContentWidth + breakpointLgHorizontalPadding;
  };
  var getHalfTooltipWidth = function getHalfTooltipWidth() {
    return getTooltipWidth() / 2;
  };
  var cleanup = function cleanup() {
    setLeftOffset(null);
    setRightOffset(null);
    setUseNaturalPosition(false);
  };

  /* eslint-disable max-statements */
  (0, _react.useEffect)(function () {
    if (!wrapperRef.current) {
      return;
    }
    if (showTooltip) {
      var rect = wrapperRef.current.getBoundingClientRect();
      var largerChild = rect.width >= getTooltipWidth();
      if (largerChild && !isMobile) {
        setUseNaturalPosition(true);
        setChildIsLarger(true);
        return;
      }
      if (isMobile || rect.x <= getHalfTooltipWidth()) {
        setLeftOffset("".concat(-rect.x, "px"));
        setUseNaturalPosition(false);
        return;
      }
      if (rect.right + getHalfTooltipWidth() > windowWidth) {
        setRightOffset("-".concat(windowWidth - rect.right, "px"));
        setUseNaturalPosition(false);
        return;
      }
      setUseNaturalPosition(true);
    } else {
      cleanup();
    }
  }, [showTooltip]);
  var isTooltipHidden = !leftOffset && !rightOffset && !useNaturalPosition;
  return {
    isMobile: isMobile,
    isTooltipHidden: isTooltipHidden,
    leftOffset: leftOffset,
    rightOffset: rightOffset,
    childIsLarger: childIsLarger
  };
};